import toDate from './toDate.js'
/*
@value Date | String | Number: 原生日期对象, 日期值或毫秒时间戳
@rule String: 格式化的规则字符串, YYMM-MM-DD hh:mm:ss
*/
const DEFAULT_RULE = 'YYYY-MM-DD'
const REGEX_FORMAT = /\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g

const zero = function (value) {
  const str = String(value)
  return value > 9 ? str : '0' + str
}
const h = function (hour) {
  return hour > 12 ? hour % 12 : hour
}

export default function (value, rule = DEFAULT_RULE) {
  if (value === '') {
    return ''
  }

  const date = toDate(value)
  const year = String(date.getFullYear())
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()

  const matches = {
    YY: year.slice(-2),   // 2018 -> 18
    YYYY: year, // 2018
    M: month,   // 1 - 12
    MM: zero(month),  // 01 - 12
    D: String(day),   // 1 - 31
    DD: zero(day),  // 01 - 31
    H: String(hours),   // 0 - 23
    HH: zero(hours),  // 00 - 23
    h: h(hours),   // 1 - 12
    hh: zero(h(hours)),  // 01 - 12
    m: String(minutes),   // 0 - 59
    mm: zero(minutes),  // 00 - 59
    s: String(seconds),   // 0 - 59
    ss: zero(seconds),  // 00 - 59
  }

  return rule.replace(REGEX_FORMAT, (match, $1) => $1 || matches[match])
}